import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, InjectionToken } from '@angular/core';
import { provideClientHydration } from '@angular/platform-browser';
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withInMemoryScrolling,
  withRouterConfig,
} from '@angular/router';

import { AuthConfig, OAuthModule } from 'angular-oauth2-oidc';
import { MarkdownModule, MarkedOptions } from 'ngx-markdown';

import { provideApollo } from '@/apollo.config';
import { environment } from './../environments/environment';
import { provideAppIcons } from '@/provide-app-icons';
import { provideAuth } from '@/provide-auth';
import { provideBaseHref } from '@/provide-base-href';
import { provideLibConfig } from '@/provide-lib-config';

import { appRoutes } from './app.routes';
import { provideImages } from './provide-image';
import { ENV_NAME } from './shared/tokens';
import { provideVmThemeIcons } from '@virginmediao2/momentum-angular';
import { LottieCacheModule, LottieModule } from 'ngx-lottie';

export const APP_BASE = new InjectionToken<AuthConfig>('APP_BASE');

export function playerFactory() {
  return import('lottie-web/build/player/lottie_light');
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBaseHref(), // TODO REMOVE
    provideRouter(
      appRoutes,
      withEnabledBlockingInitialNavigation(),
      withRouterConfig({ onSameUrlNavigation: 'reload' }),
      withInMemoryScrolling({ scrollPositionRestoration: 'top' })
    ),
    provideClientHydration(),
    provideHttpClient(withInterceptors(environment.interceptors)),
    provideApollo(),
    provideAppIcons(),
    provideVmThemeIcons(),
    provideAuth(),
    provideImages(),
    provideLibConfig(), // TODO REMOVE
    importProvidersFrom(LottieModule.forRoot({ player: playerFactory })), // TODO MAKE single 
    importProvidersFrom(LottieCacheModule.forRoot()),
    importProvidersFrom(
      MarkdownModule.forRoot({
        markedOptions: {
          provide: MarkedOptions,
          useValue: {
            headerIds: false,
            mangle: false,
          },
        },
      })
    ),
    importProvidersFrom(OAuthModule.forRoot()),
    { provide: ENV_NAME, useValue: environment.name },
  ],
};
